import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'th.employer.seek.com',
    clientId: 'oiubQcLIcjayEQcPJDnQLL58e7FXBOPk',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://th.jobsdb.com/en-th/cms/employer/recruitment-tips-and-guides/',
        th: 'https://th.jobsdb.com/th-th/cms/employer/recruitment-tips-and-guides/',
    },
    siteName: siteNames.employer.seek.th,
    zone: getZoneFromSite(siteNames.employer.seek.th),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=th_employer_seek_com.js.map